import React from 'react';
import { IonIcon } from '@ionic/react';
import { chevronDown, chevronForward } from 'ionicons/icons';
import '../MailSidebar/MailSidebar.css'; // Reuse mail sidebar styles

/**
 * Reusable Sidebar Component
 * Supports expandable sections with submenus
 */
const Sidebar = ({ 
  buttonSection,  // Top button (compose/new)
  navItems,       // Array of navigation items
  bottomSection   // Optional bottom section (storage, etc.)
}) => {
  return (
    <div className="mail-sidebar">
      {/* Button Section */}
      {buttonSection && (
        <div className="mail-compose-section">
          {buttonSection}
        </div>
      )}

      {/* Navigation */}
      <nav className="mail-sidebar-nav">
        {navItems.map((item, index) => (
          <SidebarItem key={index} {...item} />
        ))}
      </nav>

      {/* Bottom Section */}
      {bottomSection && bottomSection}
    </div>
  );
};

/**
 * Individual sidebar item - can be expandable or simple
 */
const SidebarItem = ({
  label,
  icon,
  isActive,
  isExpandable,
  isExpanded,
  onToggle,
  onClick,
  subitems,
  count
}) => {
  if (isExpandable) {
    return (
      <div className="account-group expandable">
        <button
          className={`mail-account-header ${isActive ? 'active' : ''}`}
          onClick={onToggle}
        >
          <div className="mail-account-text">
            <div className="mail-account-name">
              {icon && <IonIcon icon={icon} style={{ marginRight: '8px' }} />}
              {label}
            </div>
          </div>
          <IonIcon 
            icon={isExpanded ? chevronDown : chevronForward} 
            className="expand-icon"
          />
        </button>
        
        {isExpanded && subitems && (
          <div>
            {subitems.map((subitem, idx) => (
              <button 
                key={idx}
                className={`nav-link mail-folder-item ${subitem.isActive ? 'active' : ''}`}
                onClick={subitem.onClick}
              >
                <div className="folder-content">
                  {subitem.icon && <IonIcon icon={subitem.icon} className="folder-icon" />}
                  <span className="folder-label">{subitem.label}</span>
                </div>
                {subitem.count !== undefined && (
                  <span className="folder-count">{subitem.count}</span>
                )}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  // Simple item (non-expandable)
  return (
    <div className="account-group">
      <button
        className={`nav-link ${isActive ? 'active' : ''}`}
        onClick={onClick}
      >
        <div className="folder-content">
          {icon && <IonIcon icon={icon} className="folder-icon" />}
          <span className="folder-label">{label}</span>
        </div>
        {count !== undefined && (
          <span className="folder-count">{count}</span>
        )}
      </button>
    </div>
  );
};

export default Sidebar;

